import IDate from '@shared/types/interfaces/date';
import { ICategory } from '../types/interfaces/category';
import { RailDisplayMode, RailOrderType } from '../types/enums/rail';

class Category {
  id: string;
  date?: IDate;
  name: string;
  orderField: string;
  orderSort?: RailOrderType;
  presentationType: RailDisplayMode;
  score: number;
  title: string;
  type: string;

  constructor(request: ICategory) {
    this.id = request.id;
    this.date = {
      start: new Date(request.created).getTime(),
      end: new Date(request.updated).getTime(),
    };
    this.name = request.name;
    this.orderField = request.orderField;
    this.orderSort = request.orderSort;
    this.presentationType =
      request?.name === 'cine'
        ? RailDisplayMode.POSTER
        : (request.presentationType as RailDisplayMode);
    this.score = request.order;
    this.title = request.title;
    this.type = request.name;
  }

  getSortingCriteria() {
    return [this.orderField, this.orderSort];
  }
}

export default Category;
